module.exports = __webpack_public_path__ + "static/media/TCN20-350x210.d9083f15.png";